(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "collection-product-grid",
    class extends e.default {
      render() {
        this.listenTo("filterChange", (e, t) => {
          this._update(t.html);
        }),
          this.listenTo("sortChange", (e, t) => {
            this._update(t.html);
          });
      }

      _update(e) {
        e = new DOMParser()
          .parseFromString(e, "text/html")
          .getElementById("CollectionProductGrid");
        this.replaceChildren(...e.childNodes);
      }
    }
  );
})();
